"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 清除路徑字串中的相對路徑
 * @param path 路徑
 */
function cleanPath(path) {
    var temp = [];
    var segs = path.split('/');
    for (var i = 0; i < segs.length; i++) {
        if (segs[i].length === 0 || segs[i].trim() === '.') {
            continue;
        }
        if (segs[i].trim() === '..' &&
            i > 0 &&
            (temp[temp.length - 1] !== '.' && temp[temp.length - 1] !== '..')) {
            temp.pop();
            continue;
        }
        temp.push(segs[i]);
    }
    return temp.join('/');
}
exports.cleanPath = cleanPath;

//# sourceMappingURL=cleanPath.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/cleanpath/cleanPath.js
// module id = ./node_modules/cleanpath/cleanPath.js
// module chunks = vendor